import { render } from "./PasswordResetDialog.vue?vue&type=template&id=39bc501d&scoped=true"
import script from "./PasswordResetDialog.vue?vue&type=script&lang=js"
export * from "./PasswordResetDialog.vue?vue&type=script&lang=js"

import "./PasswordResetDialog.vue?vue&type=style&index=0&id=39bc501d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bc501d"]])

export default __exports__